<template>
  <div>
    <h3 class="text-center">填写咨询方案前置问卷（1/3）</h3>
    <el-card class="box-card">
      <p>亲爱的同学： </p>
      <p>
        你好！正式开始咨询前，需要你先填写此问卷，方便咨询师详细了解你的情况，据此制定适合你的咨询方案，从而让咨询高效进行。</p>
      <el-form :model="preQuizPart1" :rules="rules" ref="formStep1" label-position="top">
        <el-form-item label="1、此次来想咨询的问题是什么？" prop="consultQuestion">
          <el-input v-model="preQuizPart1.consultQuestion"></el-input>
        </el-form-item>
        <el-form-item label="2、此次来想咨询的主题是：（可多选）" prop="resolve">
          <el-checkbox-group v-model="preQuizPart1.resolve">
            <el-checkbox label="大学生活适应">大学生活适应（大学环境、学习、人际、生活的适应等）</el-checkbox>
            <el-checkbox label="学业规划">学业规划（专业选择，学习方法和计划制定等）</el-checkbox>
            <el-checkbox label="自我管理技能">自我管理技能（时间管理、学业与生活/实习平衡、拖延问题等）</el-checkbox>
            <el-checkbox label="自我了解">自我了解（性格、兴趣、能力、价值观等）</el-checkbox>
            <el-checkbox label="职业探索">职业探索（职业选择范围拓展、职业/行业信息搜集方法等）</el-checkbox>
            <el-checkbox label="职业定位">职业定位（职业目标明确、决策困难等）</el-checkbox>
            <el-checkbox label="毕业去向选择">毕业去向选择（工作、考研、出国的选择、跨专业考研等）</el-checkbox>
            <el-checkbox label="求职技巧">求职技巧（简历/面试指导、求职渠道和资源等）</el-checkbox>
            <el-checkbox label="就业心理调适">就业心理调适（求职动力不足、考研焦虑、求职受挫等）</el-checkbox>
            <el-checkbox label="就业形势与政策解读">就业形势与政策解读（选调生、基层就业、创业政策等）</el-checkbox>
            <el-checkbox label="职场适应">职场适应（岗位适应、职场人际适应、职场压力应对等）</el-checkbox>
            <el-checkbox label="其他">其他
              <el-input v-model="preQuizPart1.resolveOther"></el-input>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="3、你期望通过生涯咨询，达到什么样的效果？" prop="effect">
          <el-input v-model="preQuizPart1.effect"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <br>
    <el-button type="primary" round style="width:100%" @click="next">下一页</el-button>
    <br>
    <br>
  </div>
</template>

<script>
import qs from "qs";

export default {
  data() {
    return {
      preQuizPart1: {
        consultQuestion: '',
        resolve: [],
        resolveOther: '',
        effect: '',
      },
      rules: {
        consultQuestion: [
          {required: true, message: '请输入内容', trigger: 'blur'},
        ],
        resolve: [
          {type: 'array', required: true, message: '请至少选择一个', trigger: 'change'}
        ],
        effect: [
          {required: true, message: '请输入内容', trigger: 'blur'},
        ],
      }
    };
  },
  mounted() {
  },
  methods: {
    next() {
      let preQuizPart1 = this.preQuizPart1
      this.$refs["formStep1"].validate((valid) => {
        if (valid) {
          if (preQuizPart1.resolve.includes('其他')) {
            if (preQuizPart1.resolveOther.trim().length === 0) {
              this.$message({
                message: '请填写主要想解决的问题中的其他选项',
                type: 'warning'
              });
              return false;
            }
          }
          sessionStorage.setItem("preQuizPart1", JSON.stringify(this.preQuizPart1));
          this.$router.push('fillPreQuiz2');
        } else {
          return false;
        }
      });
    },
  }
};
</script>


<style scoped>
>>> .el-checkbox__label {
  display: inline-grid;
  width: 300px;
  white-space: pre-line;
  word-wrap: break-word;
  line-height: 17px;
  font-size: 13px;
}

>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>
